import { getServiceUrl } from './api.config';
import { ApiClientOptions } from './types/api';
import ApiClient from './utils/ApiClient';
import qs from './utils/query';
import { isNotEmptyArray, isPositiveInteger } from './utils/validators';

export default class ExchangeApi extends ApiClient {
  public constructor(options?: ApiClientOptions) {
    super(getServiceUrl('exchange'), options);
  }

  public EndpointCreate(entity: any) {
    const query = '/exchange/v1/endpoint';
    return this.post(query, entity);
  }

  public EndpointUpdate(entity: any) {
    const query = `/exchange/v1/endpoint/${entity.id}`;
    return this.put(query, entity);
  }

  public EndpointDelete(entityId: number) {
    const query = `/exchange/v1/endpoint/${entityId}`;
    return this.delete(query, {});
  }

  public EndpointList(filters: any) {
    const query = `/exchange/v1/endpoint/list`;
    const params: any = {};

    if (isNotEmptyArray(filters.filter_organization_in)) {
      params.filter_organization_in = filters.filter_organization_in.join();
    }
    if (isPositiveInteger(filters.offset)) {
      params.offset = filters.offset;
    }
    if (isPositiveInteger(filters.limit)) {
      params.limit = filters.limit;
    }
    return this.get(query, qs.stringify(params, true));
  }

  public EndpointListFile(endpointId: number, limit: number, offset: number) {
    const query = `/exchange/v1/endpoint/${endpointId}/files`;
    const params: any = {};
    params.limit = limit;
    params.offset = offset;
    return this.get(query, qs.stringify(params, true));
  }

  public EndpointHandlerCreate(endpointId: number, entity: any) {
    const query = `/exchange/v1/endpoint/${endpointId}/handler`;
    return this.post(query, entity);
  }

  public EndpointHandlerUpdate(endpointId: number, entity: any) {
    const query = `/exchange/v1/endpoint/${endpointId}/handler/${entity.id}`;
    return this.put(query, entity);
  }

  public EndpointHandlerDelete(endpointId: number, ephId: number) {
    const query = `/exchange/v1/endpoint/${endpointId}/handler/${ephId}`;
    return this.delete(query, {});
  }

  public EndpointListFilters() {
    const query = `/exchange/v1/endpoint/list/filters`;
    return this.get(query);
  }

  public GMAILConsent(entity: any) {
    const query = '/exchange/v1/gmail/generatetoken';
    return this.post(query, entity);
  }
}
